import React from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import { colors } from "../../theme";

interface Props {
  selectedRegion: string | undefined;
  setSelectedRegion: (region: string | undefined) => void;
  continent: string;
  country: string;
  region: string | undefined;
  municipality: string | undefined;
}

const useStyles = makeStyles((theme) => ({
  label: {
    fontSize: "16px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "2",
    letterSpacing: "-0.04px",
    color: colors.TEXT_SECONDARY,
    paddingRight: "10px",
  },
  select: {
    border: "0",
    height: "27px",
    paddingLeft: "5px",
    width: "138px",
    color: colors.TEXT_SECONDARY,
  },
  option: {},
}));

export default function RegionFilter({
  selectedRegion,
  setSelectedRegion,
  continent,
  country,
  region,
  municipality,
}: Props) {
  const classes = useStyles();
  const { t } = useTranslation();

  const handleRegionToggle = (event: any) => {
    const region = event.target.value;
    setSelectedRegion(region);
  };

  return (
    <>
      <span className={classes.label}>{t("regionfilter.filter")}</span>
      <select
        value={selectedRegion}
        onChange={handleRegionToggle}
        className={classes.select}
      >
        <option value={undefined} className={classes.option}>
          {t("regionfilter.all")}
        </option>
        <option value="continent" className={classes.option}>
          {continent}
        </option>
        <option value="country" className={classes.option}>
          {country}
        </option>
        {region && (
          <option value="region" className={classes.option}>
            {region}
          </option>
        )}
        {municipality && (
          <option value="municipality" className={classes.option}>
            {municipality}
          </option>
        )}
      </select>
    </>
  );
}
